import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getGrupoFisicoList } from './selectdbAtions';
import { getConfig, setConfig } from '../../configuracao/configLocal';
import { getConfControladorGrupoList } from './selectdbAtions';

import './contentHeaderFilter.css';

/**
 * Seleção virtual "todos os grupos". Não é persistida em `configLocal` — lá o
 * grupo continua 0, que as outras telas já entendem como "sem filtro". Assim o
 * default ao entrar na página segue sendo "Selecione".
 */
export const GRUPO_TODOS = 'todos';

class SelectConfGrupoFisico extends Component {
  constructor(props) {
    super(props);

    this.state = {
      value: getConfig('grupo'),
      aguardandoGrupos: true,
      falhaGrupos: false,
    };
    this._timerGrupos = null;
  }

  componentWillMount() {
    this.props.getGrupoFisicoList();
    this._timerGrupos = setTimeout(() => {
      if (!(this.props.list && this.props.list.length)) {
        this.setState({ aguardandoGrupos: false, falhaGrupos: true });
      }
    }, 26000);
  }

  componentWillUnmount() {
    if (this._timerGrupos) clearTimeout(this._timerGrupos);
  }

  componentDidUpdate(prevProps) {
    const list = this.props.list || [];
    if (list.length && list !== prevProps.list) {
      this.setState({ aguardandoGrupos: false, falhaGrupos: false });
      if (this._timerGrupos) {
        clearTimeout(this._timerGrupos);
        this._timerGrupos = null;
      }
    }
  }

  renderOptions() {
    const list = this.props.list || [];

    if (list.length === 0) {
      if (this.state.falhaGrupos) {
        return <option value="">Servidor de dados indisponível</option>;
      }
      if (this.state.aguardandoGrupos) {
        return <option value="">Carregando...</option>;
      }
      return <option value="">Nenhum grupo cadastrado</option>;
    }

    return list.map(grupo => (
      <option key={grupo.id} value={grupo.id}>
        {grupo.id} - {grupo.descricao}
      </option>
    ));
  }

  handleChange(event) {
    const valor = event.target.value;
    this.setState({ value: valor });
    setConfig('grupo', valor === GRUPO_TODOS ? 0 : valor);
    setConfig('cont', 0);
    setConfig('numCont', 0);
    setConfig('anel', 0);
    this.props.getConfControladorGrupoList();
    if (this.props.onChange) {
      this.props.onChange(valor);
    }
  }

  render() {
    const defaultStyle = { width: '160px', display: 'inline' };
    const finalStyle = this.props.customStyle ? this.props.customStyle : defaultStyle;

    return (
      <div style={{ marginTop: '0px' }}>
        {!this.props.customStyle && (
          <label style={{ display: 'inline' }} htmlFor={'selectGrupoFisico'}>
            <small>Grupo Físico: </small>
          </label>
        )}
        <select
          id={'selectGrupoFisico'}
          name={'selectGrupoFisico'}
          style={finalStyle}
          className={this.props.customStyle ? '' : 'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="">{this.props.emptyText || 'Selecione...'}</option>
          {this.props.todosText && <option value={GRUPO_TODOS}>{this.props.todosText}</option>}
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ list: state.grupoFisicoCad.list });
const mapDispatchToProps = dispatch =>
  bindActionCreators({ getGrupoFisicoList, getConfControladorGrupoList }, dispatch);
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectConfGrupoFisico);
